import { SearchProduct } from '@epicuro-next/models/products';
import { MediaType, ProductMedia } from 'graphql-api/gql-api-interfaces';

export const mediaTypes = {
  image: MediaType.Image,
  video: MediaType.Video,
  '360': MediaType.Image360,
};

export function mapProductMedia(
  product: SearchProduct | undefined,
): ProductMedia[] {
  let productMedia: ProductMedia[] = [];

  if (product?.media) {
    productMedia = product.media.map((mediaItem): ProductMedia => {
      const type = mediaTypes[mediaItem.type];
      return {
        url: mediaItem.src[0]?.url ?? '',
        urls:
          type === MediaType.Image360
            ? mediaItem.src.map(({ url }) => url)
            : [],
        type,
      };
    });
  }
  return productMedia;
}
